/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Manager of the file's legal entity, as shown on a formula meant for an individual.
 * @export
 * @interface FormulasManagerDto
 */
export interface FormulasManagerDto {
    /**
     * 
     * @type {string}
     * @memberof FormulasManagerDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormulasManagerDto
     */
    lastName?: string | null;
}

/**
 * Check if a given object implements the FormulasManagerDto interface.
 */
export function instanceOfFormulasManagerDto(value: object): value is FormulasManagerDto {
    return true;
}

export function FormulasManagerDtoFromJSON(json: any): FormulasManagerDto {
    return FormulasManagerDtoFromJSONTyped(json, false);
}

export function FormulasManagerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormulasManagerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
    };
}

export function FormulasManagerDtoToJSON(json: any): FormulasManagerDto {
    return FormulasManagerDtoToJSONTyped(json, false);
}

export function FormulasManagerDtoToJSONTyped(value?: FormulasManagerDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}

